<div class="row" *ngIf="candidate">
  <div class="col-12">

    <!-- <h3 class="mb-5">{{ texts.title | localize }}</h3> -->

    <div class="pretitle mb-3">{{ texts.title | localize }}</div>

    <p class="mb-4" *ngIf="!candidate.Experience?.length">
      {{ texts.noInformation | localize }}
    </p>

    <ul class="list-group list-group-flush fw-normal">

      <li *ngFor="let entry of candidate.Experience" class="list-group-item">

        <div class="row">

          <div class="col-12 col-md">
            <h6 class="mb-0">{{entry.Title}}</h6>
            <p class="mb-0">{{entry.Company}}</p>

            <div class="row" *ngIf="entry.Description">
              <div class="col-12">
                <p class="mt-2 mb-0 fw-normal text-muted">{{ entry.Description }}</p>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-auto mt-2 mt-md-0">

            <p *ngIf="!entry.ToPresent && entry.Start && entry.End && entry.Start != entry.End"
              class="small text-right mb-0">
              {{ entry.Start | date:'MM/y'}} {{ texts.to | localize }} {{ entry.End | date:'MM/y'}}<br>
              <span>{{ entry.Start | humanizedDateDiff : entry.End }}</span>
            </p>

            <p *ngIf="!entry.ToPresent && entry.Start && entry.End && entry.Start == entry.End"
              class="small text-right mb-0">
              {{ entry.Start | date:'MM/y'}}<br>
              <span>{{ texts.aboutOneMonth | localize }}</span>
            </p>

            <p *ngIf="!entry.ToPresent && entry.Start && !entry.End" class="small text-right mb-0">
              {{ entry.Start | date:'MM/y'}}<br>
              <span>{{ texts.unknownDuration | localize }}</span>
            </p>

            <p *ngIf="entry.ToPresent && entry.Start" class="small text-right mb-0">
              {{ entry.Start | date:'MM/y'}} {{ texts.toPresent | localize }}<br>
              <span *ngIf="entry.Start">{{ entry.Start | humanizedDateDiff }}</span>
            </p>

            <p *ngIf="entry.ToPresent && !entry.Start" class="small text-right mb-0">
              {{ texts.toPresent | localize }}<br>
              <span *ngIf="entry.Start">{{ texts.unknownDuration | localize }}</span>
            </p>

          </div>

        </div>

      </li>

    </ul>

  </div>
</div>